import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rub",
  "use": "icon-rub-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol viewBox=\"0 0 9 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rub\">\r\n<path d=\"M0 6.848H1.6V8.096H0V9.024H1.6V11.2H2.72V9.024H6.576V8.096H2.72V6.848H4.96C7.664 6.848 8.96 5.552 8.96 3.424C8.96 1.28 7.68 0 4.96 0H1.6V5.824H0V6.848ZM4.96 1.024C6.96 1.024 7.808 1.872 7.808 3.424C7.808 4.992 6.976 5.824 4.96 5.824H2.72V1.024H4.96Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol